/**
 * Validate Bhutan mobile number (starts with 17 or 77, 8 digits)
 */
export function isValidBhutanMobile(phone) {
  return /^(17|77)\d{6}$/.test(phone);
}

/**
 * Validate booking date and time are in the future
 */
export function isFutureDateTime(date, time) {
  const selectedDate = new Date(`${date}T${time}`);
  const now = new Date();
  return selectedDate > now;
}

/**
 * Validate business hours (10:00 to 20:00)
 */
export function isWithinBusinessHours(time) {
  const [hours, minutes] = time.split(":");
  const hourInt = parseInt(hours, 10);
  const minuteInt = parseInt(minutes, 10);
  return hourInt >= 10 && hourInt <= 20 && !(hourInt === 20 && minuteInt > 0);
}

/**
 * Format phone number for storage and backend: add 975 in front
 */
export function formatBhutanPhone(phone) {
  return `975${phone}`;
}

/**
 * Format time to include AM/PM
 */
export function formatTimeWithAmPm(time) {
  const [hours, minutes] = time.split(":");
  return `${+hours % 12 || 12}:${minutes} ${+hours >= 12 ? "PM" : "AM"}`;
}

/**
 * Generate time options for booking (10:00 to 19:50, every 10 min)
 */
export function generateTimeOptions() {
  const times = [];
  for (let h = 10; h < 20; h++) {
    for (let m = 0; m < 60; m += 10) {
      if (h === 19 && m > 0) break;
      const hourStr = h.toString().padStart(2, "0");
      const minStr = m.toString().padStart(2, "0");
      times.push(`${hourStr}:${minStr}`);
    }
  }
  return times;
}
